var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.204,
    height: 66.736,
    viewBox: "0 0 66.204 66.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.102,
    x2: 0.935,
    y2: 0.936,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#daeeff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1092",
    "data-name": "Rechteck 1092",
    width: 38.574,
    height: 47.9,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3843",
    "data-name": "Gruppe 3843",
    transform: "translate(-207 -260.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M28.077.2A63.31,63.31,0,0,1,36.3.092,54.985,54.985,0,0,1,47.4,1.65a26.079,26.079,0,0,1,9.011,4.12,21.417,21.417,0,0,1,4.128,4.19,24.853,24.853,0,0,1,3.575,7.39,48.759,48.759,0,0,1,1.863,10.519,67.073,67.073,0,0,1-.692,16.592,34.057,34.057,0,0,1-2.82,9.137,20.513,20.513,0,0,1-9.492,9.473c-4.739,2.289-10.014,3.135-15.213,3.5a66.318,66.318,0,0,1-7,.136,60.775,60.775,0,0,1-10.673-1.3,28.907,28.907,0,0,1-8.746-3.383,20.559,20.559,0,0,1-4.919-4.27,24.64,24.64,0,0,1-4.6-9.284,58.1,58.1,0,0,1-1.8-13.2A70.074,70.074,0,0,1,.647,24.051c.685-4.858,2-9.772,4.835-13.831a21.678,21.678,0,0,1,3.04-3.388,21.784,21.784,0,0,1,6.643-4A44.761,44.761,0,0,1,28.077.2",
    transform: "translate(207 260.215)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3801",
    "data-name": "Gruppe 3801",
    transform: "translate(220.815 269.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3781",
    "data-name": "Gruppe 3781",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3780",
    "data-name": "Gruppe 3780",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1091",
    "data-name": "Rechteck 1091",
    width: 25.475,
    height: 25.475,
    transform: "translate(1.274 28.613) rotate(-45)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4037",
    "data-name": "Pfad 4037",
    d: "M1.511,28.5v-9l18-18,18.014,18v9",
    transform: "translate(-0.228 -0.226)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_117",
    "data-name": "Linie 117",
    y2: 9.52,
    transform: "translate(19.287 1.274)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_118",
    "data-name": "Linie 118",
    y1: 4.13,
    x2: 18.783,
    transform: "translate(2.729 23.633)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Linie_119",
    "data-name": "Linie 119",
    x2: 4.484,
    y2: 19.689,
    transform: "translate(19.193 11.52)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3783",
    "data-name": "Gruppe 3783",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3782",
    "data-name": "Gruppe 3782",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_120",
    "data-name": "Linie 120",
    x2: 4.546,
    y2: 20.891,
    transform: "translate(14.316 25.31)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_121",
    "data-name": "Linie 121",
    y1: 4.29,
    x2: 20.198,
    transform: "translate(16.558 28.579)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBg);
export default __webpack_public_path__ + "static/media/logo-bg.7809bc91c652c075826e60f7ce4a000f.svg";
export { ForwardRef as ReactComponent };